import React, { useState } from 'react';
import { AppBar, Toolbar, Typography, Drawer, List, ListItem, ListItemText, Box, Button } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';

const drawerWidth = 240;

const Layout = ({ children, isLoggedIn }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [selectedIndex, setSelectedIndex] = useState(location.pathname);

    const handleListItemClick = (event, index) => {
        setSelectedIndex(index);
        navigate(index);
    };
    const handleNav=()=>{
        localStorage.removeItem('loggedIn') 
        navigate("/")
        window.location.reload();
    }

    return (
        <>
            {isLoggedIn && <Box sx={{ display: 'flex' }}>
                <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
                    <Toolbar>
                        <Typography variant="h6" noWrap component="div">
                            Prathna Admin Panel
                        </Typography>
                        <Box sx={{ flexGrow: 1 }} />
                        <Button color="inherit" onClick={() => {handleNav()}}>
                            Logout
                        </Button>
                    </Toolbar>
                </AppBar>
                <Drawer
                    variant="permanent"
                    sx={{
                        width: drawerWidth,
                        flexShrink: 0,
                        [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' },
                    }}
                >
                    <Toolbar />
                    <Box sx={{ overflow: 'auto' }}>
                        <List>
                            <ListItem
                                button
                                selected={location.pathname === '/home' || location.pathname === '/'}
                                onClick={(event) => handleListItemClick(event, '/home')}
                            >
                                <ListItemText primary="Posts Approved" />
                            </ListItem>
                            <ListItem
                                button
                                selected={location.pathname === '/posts/pending'}
                                onClick={(event) => handleListItemClick(event, '/posts/pending')}
                            >
                                <ListItemText primary="Posts Pending" />
                            </ListItem>
                            <ListItem
                                button
                                selected={location.pathname === '/posts/deleterequestlist'}
                                onClick={(event) => handleListItemClick(event, '/posts/deleterequestlist')}
                            >
                                <ListItemText primary="Delete Request List" />
                            </ListItem>
                            <ListItem
                                button
                                selected={location.pathname === '/settings'}
                                onClick={(event) => handleListItemClick(event, '/settings')}
                            >
                                <ListItemText primary="Settings" />
                            </ListItem>
                        </List>
                    </Box>
                </Drawer>
                <Box
                    component="main"
                    sx={{ flexGrow: 1, bgcolor: 'background.default', p: 3 }}
                >
                    <Toolbar />
                    {children}
                </Box>
            </Box>}
        </>
    );
};

export default Layout;
